module.exports = __webpack_public_path__ + "img/home.a3213ed5.png";